import Vue from 'vue'
import store from '@/store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)


axios.interceptors.request.use((request) => {
  store.commit('setProgress', true);
  return request;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});